<ng-select
  [hideSelected]="multiple"
  [clearable]="false"
  clearAllText="{{ 'COMMON.MULTISELECT_CLEAR_ALL' | translate }}"
  loadingText="{{ 'COMMON.MULTISELECT_LOADING' | translate }}"
  notFoundText="{{ 'COMMON.MULTISELECT_NOTFOUND' | translate }}"
  typeToSearchText="{{ 'COMMON.MULTISELECT_SEARCH_PROMPT' | translate }}"

  [items]="items"
  [multiple]="multiple"
  [placeholder]="placeholder"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [compareWith]="compareWith"
  [appendTo]="appendTo"

  (blur)="onBlur($event)"
  (focus)="onFocus($event)"
  (change)="onChange($event)"
  (open)="onOpen($event)"
  (close)="onClose($event)"
  (search)="onSearch($event)"
  (clear)="onClear($event)"
  (add)="onAdd($event)"
  (remove)="onRemove($event)"
  (scrollToEnd)="onScrollToEnd($event)"
  >
  <ng-template ng-label-tmp let-item="item" let-clear="clear" let-label="label">
    <ng-template #defaultSelectedItemTemplate>
      <span class="multi-select-option-selected" [ngClass]="this.automationId + '_options ' + this.automationId + '_selected'">{{label}}</span>
    </ng-template>

    <div class="ng-value-label">
      <ng-template [ngTemplateOutlet]="selectedItemTemplate || defaultSelectedItemTemplate" [ngTemplateOutletContext]="{ item: item, clear: clear, label: label }"></ng-template>
    </div>

    <i class="fa fa-times ui-select-match-close ng-value-icon" (click)="clear(item)"></i>
  </ng-template>
  <ng-template ng-option-tmp let-option="item$" let-item="item" let-index="index" let-searchTerm="searchTerm">
    <ng-template #defaultItemTemplate>
      <span class="multi-select-option" [ngClass]="this.automationId + '_options'" [attr.data-automation]="this.automationId + '_option_' + index">{{option.label}}</span>
    </ng-template>

    <div class="ng-option-label">
      <ng-template [ngTemplateOutlet]="listItemTemplate || defaultItemTemplate" [ngTemplateOutletContext]="{ item: item, index: index, searchTerm: searchTerm }"></ng-template>
    </div>
  </ng-template>
</ng-select>
